import activate from './activate'
export { activate }